import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, SearchIcon, HelpCircleIcon } from 'lucide-react';
import { faqItems } from '../data/blog';
import { Button } from '../components/ui/Button';
export function FAQPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const [openItem, setOpenItem] = useState<string | null>(null);
  const [activeCategory, setActiveCategory] = useState<string>('Всі');
  const categories = ['Всі', ...Array.from(new Set(faqItems.map(item => item.category)))];
  const filteredItems = faqItems.filter(item => {
    const matchesSearch = item.question.toLowerCase().includes(searchQuery.toLowerCase()) || item.answer.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = activeCategory === 'Всі' || item.category === activeCategory;
    return matchesSearch && matchesCategory;
  });
  return <main className="min-h-screen bg-slate-50" data-id="element-801">
      {/* Breadcrumbs */}
      <div className="bg-white border-b border-slate-100" data-id="element-802">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-803">
          <nav className="flex items-center gap-2 text-sm" data-id="element-804">
            <Link to="/" className="text-slate-500 hover:text-slate-700" data-id="element-805">
              Головна
            </Link>
            <span className="text-slate-300" data-id="element-806">/</span>
            <span className="text-slate-900 font-medium" data-id="element-807">FAQ</span>
          </nav>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-808">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-809">
          <h1 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-810">
            Часті питання
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto mb-8" data-id="element-811">
            Знайдіть відповіді на популярні питання про замовлення, доставку та
            гарантію
          </p>

          {/* Search */}
          <div className="relative max-w-xl mx-auto" data-id="element-812">
            <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Пошук питання..." className="w-full pl-12 pr-4 py-3 bg-white border border-slate-200 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent" data-id="element-813" />
            <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" data-id="element-814" />
          </div>
        </div>

        {/* Categories */}
        <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-815">
          {categories.map(category => <button key={category} onClick={() => setActiveCategory(category)} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${activeCategory === category ? 'bg-sky-500 text-white shadow-md' : 'bg-white text-slate-600 hover:bg-slate-100 border border-slate-200'}`} data-id="element-816">
              {category}
            </button>)}
        </div>

        {/* FAQ List */}
        <div className="space-y-4" data-id="element-817">
          {filteredItems.length > 0 ? filteredItems.map(item => <motion.div key={item.id} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden" data-id="element-818">
                <button onClick={() => setOpenItem(openItem === item.id ? null : item.id)} className="w-full flex items-center justify-between p-6 text-left hover:bg-slate-50 transition-colors" data-id="element-819">
                  <span className="font-semibold text-slate-900 pr-4" data-id="element-820">
                    {item.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-slate-400 transition-transform duration-200 ${openItem === item.id ? 'rotate-180' : ''}`} data-id="element-821" />
                </button>
                <AnimatePresence data-id="element-822">
                  {openItem === item.id && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-823">
                      <div className="px-6 pb-6 pt-0 text-slate-600 leading-relaxed border-t border-slate-50" data-id="element-824">
                        <div className="pt-4" data-id="element-825">{item.answer}</div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>) : <div className="text-center py-12" data-id="element-826">
              <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-827">
                <HelpCircleIcon className="w-8 h-8 text-slate-400" data-id="element-828" />
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-2" data-id="element-829">
                Нічого не знайдено
              </h3>
              <p className="text-slate-600" data-id="element-830">
                Спробуйте змінити запит або категорію
              </p>
            </div>}
        </div>

        {/* Still have questions? */}
        <div className="mt-16 bg-sky-50 rounded-2xl p-8 text-center" data-id="element-831">
          <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-832">
            Не знайшли відповідь?
          </h2>
          <p className="text-slate-600 mb-6 max-w-xl mx-auto" data-id="element-833">
            Напишіть нам у Telegram — ми швидко відповімо на будь-які ваші
            запитання
          </p>
          <a href="https://t.me/aquapools_if" target="_blank" rel="noopener noreferrer" data-id="element-834">
            <Button data-id="element-835">Написати в Telegram</Button>
          </a>
        </div>
      </div>
    </main>;
}